export default __webpack_public_path__ + "static/media/monkey_black_male.456e2892.png";